import React from 'react';
import { Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '../contexts/AuthContext';

const ProtectedRouteInner = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Chargement...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/bo/login" replace />;
  }

  return children;
};

const ProtectedRoute = ({ children }) => {
  return (
    <AuthProvider>
      <ProtectedRouteInner>{children}</ProtectedRouteInner>
    </AuthProvider>
  );
};

export default ProtectedRoute;
